module.exports = __webpack_public_path__ + "img/hotel-gat-rossio.77e5fc7a.jpg";